const initialState = {
  isLoading: false,
  items: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_RECENT_ITEMS_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case 'UNSET_RECENT_ITEMS_LOADING':
      return {
        ...state,
        isLoading: false,
      };
    case 'RECEIVE_RECENT_ITEM': {
      return {
        ...state,
        items: [...state.items, action.item],
      };
    }
    default:
      return state;
  }
};
